'use client';

import { SignInPage } from 'app/(main)/accounts/sign-in/SignInPage';

export default function Page() {
  return (
    <>
      <title>로그인/회원가입 | 디리토</title>
      <SignInPage />
    </>
  );
}
